import { Container, Text } from '@pixi/react'
import { voucherTitleTextStyle } from '../selectPopup/VoucherSelectPopupTitle'
import { t } from '@slot-nx/core'

export const VoucherTotalWinTitle = () => {
  return (
    <Container name="VoucherTotalWinTitle">
      <Text
        text={t('voucher_total_win_popup_title1')}
        x={0}
        y={-610}
        anchor={[0.5, 0.5]}
        name="VoucherTotalWinTitle1"
        style={voucherTitleTextStyle}
      />
      <Text
        text={t('voucher_total_win_popup_title2')}
        x={0}
        y={-530}
        anchor={[0.5, 0.5]}
        name="VoucherTotalWinTitle2"
        style={voucherTitleTextStyle}
      />
    </Container>
  )
}
